import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import AbstractButton from '../AbstractButton';

var TextButton = function TextButton(props) {
  return /*#__PURE__*/React.createElement(AbstractButton, _extends({
    textDecoration: "underline",
    fontSize: "small",
    color: "gray-300",
    sx: {
      '&:hover': {
        textDecoration: 'none'
      }
    }
  }, props));
};

export default TextButton;